/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { App } from '../models/App';

/**
* Details about apps installed on the resource.
*/
export class AppsDetails {
  /**
  * List of app details.
  */
  'apps'?: Array<App>;
  /**
  * Whether the apps are manually overridden. If `true`, the list of apps is user-defined and remains static. If `false`, the apps are automatically detected and listed by Eon. 
  */
  'isOverridden'?: boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "apps",
      "baseName": "apps",
      "type": "Array<App>",
      "format": ""
    },
    {
      "name": "isOverridden",
      "baseName": "isOverridden",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AppsDetails.attributeTypeMap;
  }

  public constructor() {
  }
}

